import { useEffect, useRef, useState } from "react";
import { GET_LEAVE_APPROVERS, SUBMIT_LEAVE } from "../../../../config/config";
import { api, getToken } from "../../../../services/apis/auth-api/apiUrl";
import { useAuth } from "../../../../services/auth-services/authContext";
import { AuthContextState } from "../../../../utils/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faSpinner, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { AxiosError } from "axios";
import { faCopy } from "@fortawesome/free-regular-svg-icons";

interface approversProps {
    user_id : number; 
    first_name : string; 
    last_name : string;
}

const FileLeave = () => {
    const { decodedJwtData } = useAuth() as AuthContextState; 
    const account_id = decodedJwtData?.userId;
    const [leaveApprovers, setLeaveApprovers] = useState<approversProps[] | null>(null);
    const [leaveForm, setleaveForm] = useState({
        leave_type: 'vl',
        date_leaves: [] as String[],
        num_leave : 0,
        approver_id: 0,
        msg: '',
        account_id : account_id
    });
    const [submitMsg, setSubmitMsg] = useState({success: false, msg: ''});
    const [btnLoading, setButtonLoading] = useState<boolean>(false);
    const [approvalLink, setApprovalLink] = useState<string | null>(null);
    const [copyNotif, setCopyNotif] = useState<string>('');
    const inputRef = useRef<HTMLInputElement>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const dateRef = useRef<HTMLInputElement>(null);

    useEffect(()=>{
        const get_approvers = async() => {
            try{
                const api_data = await api.get(GET_LEAVE_APPROVERS, {
                    headers: { 'Authorization': 'Bearer ' + getToken() }
                });
                const approver = api_data.data as approversProps[];
                setLeaveApprovers(approver);
                setLoading(false);
            }catch(e){}
        }
        get_approvers();
    },[]);

    const copyToClipboard = () => {
        if(inputRef.current){
            navigator.clipboard.writeText(inputRef.current.value);
            setCopyNotif('Approval link copied!');
        }
    }

    const handleSubmitLeaveForm = async() => {
       try{
        console.log(leaveForm)
            const isValid = Object.entries(leaveForm)
            .filter(([key]) => key !== "account_id")
            .every(([_, value]) => value !== "" && value !== null && value !== undefined && value !== 0);
            if(!isValid) return setSubmitMsg({success: false, msg: 'All fields are required.'});
            setButtonLoading(true);
            const submitRes = await api.post(SUBMIT_LEAVE, leaveForm, {
                headers: { 'Authorization': 'Bearer ' + getToken() }
            })
            
            setButtonLoading(false);
            setSubmitMsg({success: true, msg: 'Leave request submitted!'});
            setApprovalLink(submitRes.data.approval_link);
       }catch(e){
            setButtonLoading(false);
            const error = (e as AxiosError);
            if(error.response?.status === 406){
                setSubmitMsg({success: false, msg: 'You have pending leave request or insufficient leave credits.'});
            }else{
                setSubmitMsg({success: false, msg: 'Something went wrong! Please try again.'});
            } 
       }
    }

    // useEffect(()=>{
    //     if(leaveForm.leave_type === 'sl_half'){
    //         const date = new Date();
    //         const formattedDate = date.toISOString().split('T')[0];
    //         setleaveForm({...leaveForm, date_leaves : [formattedDate]})
    //     }else{
    //         setleaveForm({...leaveForm, date_leaves : []})
    //     }
    // // eslint-disable-next-line react-hooks/exhaustive-deps
    // },[leaveForm.leave_type])

    useEffect(()=>{
        const autoValue =
        leaveForm.leave_type === 'vl' || leaveForm.leave_type === 'sl'
        ? leaveForm.date_leaves.length
        :  0.5 * leaveForm.date_leaves.length
        setleaveForm((prev) => ({ ...prev, num_leave: autoValue }));
    },[leaveForm.date_leaves, leaveForm.leave_type]);

    const handleLabelShowCalendar = () => {
        dateRef.current?.showPicker?.();
        dateRef.current?.click();
    }

    return(
        <div className="mx-2 min-w-96 text-gray-800 relative">
            <div className={loading ? 'modal-loader' : 'hidden'}>
                <FontAwesomeIcon className="animate-spin" icon={faSpinner} />
            </div>
            <div className="mb-2">
                <h1 className="text-lg">
                    Leave Form
                </h1>
            </div>
            <div>
                <small className={submitMsg.success ? 'text-green-500' : 'text-red-500'}>{submitMsg.msg}</small>
            </div>
            <div className="flex flex-col gap-2">
                <div>
                    <label>Leave type:</label>
                    <select onChange={(e)=>setleaveForm({...leaveForm, leave_type: e.target.value})} className="text-box">
                        <option value="vl">Vacation Leave</option>
                        <option value="sl">Sick/Emergency Leave</option>
                        <option value="vl_half">Vacation Leave (Half day)</option>
                        <option value="sl_half">Sick/Emergency Leave (Half day)</option>
                    </select>
                </div>
                <div className="flex gap-2 w-full">
                    <div className="w-full">
                        <div className="flex items-center">
                            <label>Date of leave/s:</label>
                            <div className={leaveForm.date_leaves.length > 0 && (leaveForm.leave_type === 'vl_half' || leaveForm.leave_type === 'sl_half') ? "hidden" : "ms-auto relative"}>
                                <label onClick={handleLabelShowCalendar} className="cursor-pointer bg-orange-400 text-sm px-2 text-white rounded hover:bg-orange-500">
                                    <FontAwesomeIcon icon={faPlus} /> &nbsp; Add date
                                </label>
                                <input type="date" ref={dateRef} id="leaveDate" onChange={(e)=>setleaveForm({...leaveForm, date_leaves: [...leaveForm.date_leaves, e.target.value]})} className="opacity-0 absolute pointer-events-none" />
                            </div>
                        </div>
                        <div className="border border-gray-600 w-full max-w-96 overflow-x-auto h-16 rounded flex items-center gap-2 px-2 relative">
                            {leaveForm.date_leaves.map((date, index) =>(
                                <div className="bg-orange-200 px-2 min-w-24 rounded text-sm shadow relative">
                                    <button type="button" onClick={()=>setleaveForm({...leaveForm, date_leaves : leaveForm.date_leaves.filter((_, i) => i !== index)})} className="absolute top-0 right-0 mb-4">
                                        <FontAwesomeIcon icon={faTimesCircle} className="text-xs text-red-600" />
                                    </button>
                                    <p>{date}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div>
                    <label>No. of leave/s:</label>
                    <input type="text" readOnly value={leaveForm.num_leave}  className="text-box" />
                </div>
                <div>
                    <label>Approver:</label>
                    <select onChange={(e)=>setleaveForm({...leaveForm, approver_id : parseInt(e.target.value)})} className="text-box">
                        <option value="">Select approver</option>
                        {leaveApprovers && leaveApprovers.map(approver => (
                            <option value={approver.user_id}>{approver.first_name} {approver.last_name}</option>
                        ))}
                    </select>
                </div>
                <div>
                    <label>Message:</label>
                    <textarea onChange={(e)=>setleaveForm({...leaveForm, msg : e.target.value})} className="text-box min-h-40 max-h-64"></textarea>
                </div>
                <div className={approvalLink ? 'block' : 'hidden'}>
                    <div>
                        <label className="text-sm">
                            Approval link: <small className="text-green-600">{copyNotif}</small>
                        </label>
                    </div>
                    <div className="flex gap-2">
                        <input type="text" ref={inputRef} className="text-box text-xs h-6" value={approvalLink ? approvalLink : ''} />
                        <button type="button" onClick={copyToClipboard} className="border w-10 rounded shadow bg-gray-200">
                            <FontAwesomeIcon icon={faCopy} />
                        </button>
                    </div>
                </div>
                <div>
                    {btnLoading ? (
                        <button type="button" className="button button-vcc-green bg-green-400 hover:bg-green-400 focus:bg-green-400 cursor-progress">
                            <FontAwesomeIcon icon={faSpinner} className="animate-spin" /> &nbsp;
                            Processing....
                        </button>
                    ) : (
                        <button type="button" onClick={handleSubmitLeaveForm} className="button button-vcc-green">Submit</button>
                    )}
                </div>
            </div>
        </div>
    );
}

export default FileLeave;